<div class="container-fluid">
	<div class="row flex-nowrap">
		<div class="w-auto col-auto col-md-1 col-xl-1 px-0">
			<app-sidebar></app-sidebar>
		</div>
		<div id="content" class="col m-0 p-0">
      <app-navbar></app-navbar>
			<app-content></app-content>
			<app-footer class="d-flex justify-content-center"></app-footer>
		</div>
	</div>
</div>
